import Menu from 'Models/Menu';

export default [
  Menu.homeDhcJobs,
  Menu.smsDhcJobs,
  Menu.callDHCJobs,
  Menu.contactFormDHCJobs,
];
